import { useMemo } from 'react';
import { connect, ConnectedProps } from 'react-redux';

import { TopGainerAndLoserData } from '../../../../lib/models/fundamental/types';
import { RootState } from '../../../../lib/store';

import { BaseTable, MarketTableItem } from '../../../../components';
import { WATCH_LIST_TABLE_HEADERS } from '../../../../components/WatchList/WatchList.constans';
import { useIsMobile } from '../../../../hooks';

type OwnProps = {
  topMoversData: TopGainerAndLoserData[],
}
type Props = OwnProps & ReduxProps;

const TopMoversTable = ({ topMoversData, companyLogoAndName }: Props) => {
  const { isMobile } = useIsMobile();
  const tableHeaders = useMemo(
    () => WATCH_LIST_TABLE_HEADERS.map((item: string) => <th key={item}>{item}</th>), [],
  );

  return (
    <BaseTable>
      {!isMobile && (<thead><tr>{tableHeaders}</tr></thead>)}
      <tbody>
        {
          topMoversData.map(({ symbol }) => (
            <MarketTableItem
              key={symbol}
              symbol={symbol}
              logo={companyLogoAndName[symbol]?.logo}
              name={companyLogoAndName[symbol]?.name}
              url={companyLogoAndName[symbol]?.url}
            />
          ))
        }
      </tbody>
    </BaseTable>
  );
};

const mapStateToProps = (state: RootState) => ({
  companyLogoAndName: state.fundamental.companyLogoAndName,
});

const connector = connect(mapStateToProps);
type ReduxProps = ConnectedProps<typeof connector>;

export default connector(TopMoversTable);
